import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { offer } from './data/offer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: offer.productName,
      value: offer.price,
      currency: offer.currency
    });
  }, []);
  return <SalesPage data-id="element-0" data-mp="2rknlod31tarc" />;
}